import { observable, action, runInAction } from 'mobx';

import Service from '@service/index';

const moSkin = observable({
  headerHeight: 60,
  partner: 'smartsalary',
  modules: <any[]>[],
  logo1: '',
  logo2: '',
  hiddenPages: <any[]>[],
  businessPlan: <any>null, // 企业套餐 - 企业VIP套餐
  customReports: <any>null, // 企业套餐 - 定制报告
  goldMember: <any>null, // 企业套餐 - 黄金会员
  priceCount: 0,
  mainColor: '',
  titleCapColor: '',
  counselor: <any>null,
  scripts: <any[]>[],
  copyright: <any[]>[],
  pricePage: [],
  favicon: '',
  footerCss: '',
  footerHtml: '',
});

const skinInit = action(async (val?: string) => {
  const res: any = await Service.getSkin(val);
  // console.log('换肤配置 -- ', res);
  if (res.partner === 'x-giants') {
    document.getElementsByTagName('title')[0].innerText = '人力资源薪酬趋势洞察平台';
  }
  if (res.partner !== 'smartsalary') {
    document.getElementById('consult')?.classList.add('none');
  }
  runInAction(() => {
    moSkin.headerHeight = res.headerHeight || 60;
    moSkin.partner = res.partner || 'smartsalary';
    moSkin.modules = res.modules || [];
    moSkin.logo1 = res.logo1 || '';
    moSkin.logo2 = res.logo2 || '';
    moSkin.hiddenPages = res.hiddenPages || [];
    moSkin.businessPlan = res.pricePage.businessPlan || null;
    moSkin.customReports = res.pricePage.customReports || null;
    moSkin.goldMember = res.pricePage.goldMember || null;
    moSkin.priceCount = res.priceCount || 0;
    moSkin.mainColor = res.mainColor || '';
    moSkin.titleCapColor = res.titleCapColor || '';
    moSkin.counselor = res.counselor || null;
    moSkin.scripts = res.scripts || [];
    moSkin.copyright = res.copyright || [];
    moSkin.pricePage = res.pricePage || [];
    moSkin.favicon = res.favicon || '';
    moSkin.footerCss = res?.footerCss;
    moSkin.footerHtml = res?.footerHtml;
  });
});

export default moSkin;
export { skinInit };
